import logo from '../assets/images/logo.jpg'
function Header(){
    return(<div>
        <img src={logo} alt={logo} />
    </div>)
}
export default Header